// e.g., src/leafletIcons.js
import L from 'leaflet';

// Import these from node_modules, or copy them into your own /public folder
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import iconNormal from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// Patch the default icon:
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: iconNormal,
  shadowUrl: iconShadow,
});
